import React, { useState, useEffect, useRef } from "react";
import styled, { keyframes } from "styled-components";
import axios from "axios";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../helpers/FirebaseConfig";
import { api } from "../../helpers/utils";

export default function CreateEvent() {
  const [event, setEvent] = useState({
    vibeTitle: "",
    vibeDesc: "",
    location: "",
    vibeType: "",
    slotTimings: "",
    endDate: "",
    maxPeople: "",
    entryAmount: "",
    locationUrl: "",
    latLong: null,
    images: [],
  });

  const [uploading, setUploading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [message, setMessage] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loadingLoc, setLoadingLoc] = useState(false);
  const autocompleteService = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);


  // ✅ Initialize Google AutocompleteService once
  useEffect(() => {
    const initAutocomplete = () => {
      if (window.google && window.google.maps) {
        autocompleteService.current =
          new window.google.maps.places.AutocompleteService();
      } else {
        console.warn("Google Maps SDK not loaded yet");
      }
    };
    initAutocomplete();
  }, []);

  // 🧠 Handle text typing and fetch suggestions
  const handleLocationChange = (value) => {
    setEvent((prev) => ({ ...prev, location: value }));

    if (!value.trim()) {
      setSuggestions([]);
      return;
    }

    if (!autocompleteService.current) return;

    setLoadingLoc(true);
    autocompleteService.current.getPlacePredictions(
      { input: value, componentRestrictions: { country: "in" } },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setSuggestions(predictions);
        } else {
          setSuggestions([]);
        }
        setLoadingLoc(false);
      }
    );
  };

  // 📍 Handle selection and get lat/long
  const handleSelectSuggestion = async (place) => {
    setEvent((prev) => ({ ...prev, location: place.description }));
    setSuggestions([]);
    try {
      const geo = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?place_id=${place.place_id}&key=AIzaSyChxeLyJDoCyTJmAm9uol0sT6HjvXFA3Bw`
      );
      if (geo.data.results?.length > 0) {
        const { lat, lng } = geo.data.results[0].geometry.location;
        setEvent((prev) => ({
          ...prev,
          latLong: { type: "Point", coordinates: [lng, lat] },
          locationUrl: `${lat},${lng}`,
        }));
        setMessage("✅ Location selected");
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🖼️ Upload image to Firebase
  const uploadImageToFirebase = async (file) => {
    const storageRef = ref(storage, `events/${Date.now()}_${file.name}`);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  };

  // 🚀 Create event
  const handleSubmit = async () => {
    if (!event.vibeTitle || !event.vibeDesc || !event.location) {
      setMessage("⚠️ Please fill all required fields");
      return;
    }
    if (!event.images.length) {
      setMessage("⚠️ Please upload an event cover image");
      return;
    }

    // handleImageUpload(event)

    

    const payload = {
      maxPeople: Number(event.maxPeople) || 50,
      creatorId: "67efd2b4b42f7e2f8f0742b8",
      creatorName: "Destiny",
      creatorProfilePic:
        "https://play-lh.googleusercontent.com/pRZWc7vL5jWlNo97c7f3eo2nzd4aBSU_kPaJIpUWNrBw8QTlvb6MVekwbozUVIui2Pg=w480-h960-rw",
      latLong: event.latLong,
      isPublic: true,
      slotTimings: event.slotTimings || "7 AM - 9 PM",
      vibeTitle: event.vibeTitle,
      venueDetails: null,
      location: event.location,
      vibeDesc: event.vibeDesc,
      isPartnered: true,
      // isVerified: true,
      dateTime: event.endDate,
      amountToPay: event.entryAmount,
      locationUrl: event.locationUrl,
      vibeType: event.vibeType,
      images: [
        "https://d2vy5rc0y5n74c.cloudfront.net/assets/groupdp.png"
      ],
      isPaid:true
    };

    if (!selectedFile) {
        setMessage("⚠️ Please select an image");
        return;
      }
    
      try {
        setCreating(true);
        setMessage("Uploading image to Firebase...");
    
        // Upload image first
        const imageUrl = await uploadImageToFirebase(selectedFile)
      setCreating(true);
      setMessage("Creating vibe...");
      await api.post("https://api1.pepchat.in/create-new-user-vibe", payload);
      setMessage("✅ Vibe created successfully!");
      setEvent({
        vibeTitle: "",
        vibeDesc: "",
        location: "",
        vibeType: "",
        slotTimings: "",
        endDate: "",
        maxPeople: "",
        entryAmount: "",
        locationUrl: "",
        latLong: null,
        images: [],
      });
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to create vibe");
    } finally {
      setCreating(false);
    }
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
        setSelectedFile(file);
      const localUrl = URL.createObjectURL(file);
      setEvent((prev) => ({ ...prev, images: [localUrl] }));
      setMessage("🖼️ Image selected");
    }
  };
  

  return (
    <Container>
      <Wrapper>
      <Left>
  {event.images.length > 0 ? (
    <ImagePreview>
      <img src={event.images[0]} alt="Event cover" />
    </ImagePreview>
  ) : (
    <UploadBox>
      <UploadLabel htmlFor="imageUpload">Select Cover Image</UploadLabel>
      <FileInput
        id="imageUpload"
        type="file"
        accept="image/*"
        onChange={handleImageSelect}
      />
    </UploadBox>
  )}
  <Text>{message}</Text>
</Left>

        <Right>
          <Title>✨ Create Vibe</Title>

          <FormGrid>
            <InputGroup>
              <Label>Vibe Title *</Label>
              <Input
                name="vibeTitle"
                value={event.vibeTitle}
                onChange={(e) =>
                  setEvent({ ...event, vibeTitle: e.target.value })
                }
                placeholder="Enter vibe title"
              />
            </InputGroup>

            <InputGroup>
              <Label>Vibe Type *</Label>
              <Input
                name="vibeType"
                value={event.vibeType}
                onChange={(e) =>
                  setEvent({ ...event, vibeType: e.target.value })
                }
                placeholder="Gym / Café / Event / etc."
              />
            </InputGroup>

            <InputGroup style={{ position: "relative" }}>
              <Label>Location *</Label>
              <Input
                name="location"
                value={event.location}
                onChange={(e) => handleLocationChange(e.target.value)}
                placeholder="Search location..."
                autoComplete="off"
              />
              {suggestions.length > 0 && (
                <SuggestionsBox>
                  {loadingLoc && <SuggestionItem>Loading...</SuggestionItem>}
                  {suggestions.map((place, i) => (
                    <SuggestionItem
                      key={i}
                      onClick={() => handleSelectSuggestion(place)}
                    >
                      <PlaceIcon>📍</PlaceIcon> {place.description}
                    </SuggestionItem>
                  ))}
                </SuggestionsBox>
              )}
            </InputGroup>

            <InputGroup>
              <Label>Timings *</Label>
              <Input
                name="slotTimings"
                value={event.slotTimings}
                onChange={(e) =>
                  setEvent({ ...event, slotTimings: e.target.value })
                }
                placeholder="e.g. 7 AM - 9 PM"
              />
            </InputGroup>

            <InputGroup>
              <Label>End Date</Label>
              <Input
                type="date"
                name="endDate"
                value={event.endDate}
                onChange={(e) =>
                  setEvent({ ...event, endDate: e.target.value })
                }
              />
            </InputGroup>

            <InputGroup>
              <Label>Max People</Label>
              <Input
                type="number"
                name="maxPeople"
                value={event.maxPeople}
                onChange={(e) =>
                  setEvent({ ...event, maxPeople: e.target.value })
                }
                placeholder="e.g. 50"
              />
            </InputGroup>

            <InputGroup>
              <Label>Entry Amount (₹)</Label>
              <Input
                type="number"
                name="entryAmount"
                value={event.entryAmount}
                onChange={(e) =>
                  setEvent({ ...event, entryAmount: e.target.value })
                }
                placeholder="e.g. 100"
              />
            </InputGroup>
          </FormGrid>

          <InputGroup>
            <Label>Description *</Label>
            <TextArea
              name="vibeDesc"
              value={event.vibeDesc}
              onChange={(e) =>
                setEvent({ ...event, vibeDesc: e.target.value })
              }
              placeholder="Describe your vibe..."
            />
          </InputGroup>

          <SubmitButton onClick={handleSubmit} disabled={creating}>
            {creating ? <Spinner /> : "Create Vibe"}
          </SubmitButton>
        </Right>
      </Wrapper>
    </Container>
  );
}

/* ======================  Styled Components  ====================== */

const Container = styled.div`
  background: #000000;
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 60px 20px 100px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  width: 100%;
  max-width: 1200px;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
`;

const Left = styled.div`
  flex: 1;
  min-width: 320px;
  background: #050505;
  border: 1px solid #303030;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Right = styled.div`
  flex: 2;
  min-width: 320px;
  width: 100%;
  background: #050505;
  padding: 40px 36px 120px;
  border: 1px solid #303030;

  @media (max-width: 900px) {
    padding: 28px 22px 100px;
  }
`;

const UploadBox = styled.div`
  width: 100%;
  height: 320px;
  background: #000000;
  border: 1px dashed #555555;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const UploadLabel = styled.label`
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
`;

const FileInput = styled.input`
  display: none;
`;

const ImagePreview = styled.div`
  width: 100%;
  height: 320px;
  overflow: hidden;
  border: 1px solid #303030;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Text = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

const Title = styled.h2`
  text-align: left;
  font-size: 34px;
  margin-bottom: 30px;
  font-weight: 700;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 25px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
`;

const Label = styled.label`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
`;

const Input = styled.input`
  background: #000000;
  border: 1px solid #303030;
  padding: 14px 16px;
  color: #ffffff;
  font-size: 15px;
  outline: none;
  transition: border 0.2s ease, box-shadow 0.2s ease;
  &:focus {
    border-color: #ffffff;
  }
`;

const TextArea = styled.textarea`
  background: #000000;
  border: 1px solid #303030;
  padding: 14px 16px;
  color: #ffffff;
  font-size: 15px;
  min-height: 120px;
  resize: vertical;
  transition: border 0.2s ease, box-shadow 0.2s ease;
  &:focus {
    border-color: #ffffff;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  background: #ffffff;
  color: #000000;
  font-size: 16px;
  font-weight: 800;
  border: 1px solid #ffffff;
  padding: 16px;
  margin-top: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: #000000;
    color: #ffffff;
    transform: translateY(-3px);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 640px) {
    position: sticky;
    bottom: 20px;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top: 3px solid #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

const SuggestionsBox = styled.div`
  position: absolute;
  top: 65px;
  left: 0;
  width: 100%;
  background: rgba(10, 10, 16, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 30;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.5);
`;

const SuggestionItem = styled.div`
  padding: 12px 15px;
  font-size: 14px;
  color: #eaeaea;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

const PlaceIcon = styled.span`
  font-size: 15px;
  opacity: 0.8;
`;
